// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2QUTW","inner":"Form_inner__29zT6","range":"Form_range__HocSx","name":"Form_name__2M1oC","actions":"Form_actions__1gFFR"};